(() => {
  document.documentElement.classList.add('gta-js-loaded');
  'use strict';

  const root = document.querySelector('[data-gta-product-page]');
  if (!root) return;

  const qs = (selector, scope = root) => scope.querySelector(selector);
  const qsa = (selector, scope = root) => [...scope.querySelectorAll(selector)];

  const moneyFormat = (() => {
    try { return JSON.parse(qs('#gta-money-format', document)?.textContent || '"${{amount}}"'); }
    catch (_) { return '${{amount}}'; }
  })();
  const variants = (() => {
    try { return JSON.parse(qs('#gta-product-variants', document)?.textContent || '[]'); }
    catch (_) { return []; }
  })();

  const formatMoney = (cents) => {
    const value = Number(cents || 0);
    const amount = (value / 100).toFixed(2);
    const amountNoDecimals = Math.round(value / 100).toString();
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  };

  const mainImage = qs('[data-gallery-main]');
  const lightbox = qs('[data-lightbox]');
  const lightboxImage = qs('[data-lightbox-image]');
  qsa('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      if (!src || !mainImage) return;
      qsa('[data-gallery-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      mainImage.style.opacity = '0.25';
      window.setTimeout(() => {
        mainImage.src = src;
        mainImage.alt = thumb.dataset.alt || '';
        if (lightboxImage) {
          lightboxImage.src = src;
          lightboxImage.alt = mainImage.alt;
        }
        mainImage.style.opacity = '1';
      }, 170);
    });
  });
  qs('[data-gallery-zoom]')?.addEventListener('click', () => {
    if (lightboxImage && mainImage) {
      lightboxImage.src = mainImage.currentSrc || mainImage.src;
      lightboxImage.alt = mainImage.alt;
    }
    if (typeof lightbox?.showModal === 'function') lightbox.showModal();
  });
  qs('[data-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });

  const tiltStage = qs('[data-tilt-stage]');
  if (tiltStage && matchMedia('(pointer:fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    tiltStage.addEventListener('pointermove', (event) => {
      const box = tiltStage.getBoundingClientRect();
      const x = ((event.clientX - box.left) / box.width - 0.5) * 2;
      const y = ((event.clientY - box.top) / box.height - 0.5) * 2;
      tiltStage.style.transform = `perspective(1200px) rotateX(${y * -2.6}deg) rotateY(${x * 2.6}deg)`;
    });
    tiltStage.addEventListener('pointerleave', () => { tiltStage.style.transform = ''; });
  }

  const selectedOptions = () => qsa('[data-option-index]').map((group) => qs('.gta-option-button.is-selected', group)?.dataset.optionValue || '');
  const getVariant = () => variants.find((variant) => variant.options.every((option, index) => option === selectedOptions()[index]));
  const variantIdInput = qs('[data-variant-id]');
  const priceNodes = qsa('[data-product-price], [data-mobile-price]');
  const addPrice = qs('[data-add-price]');
  const compareNode = qs('[data-compare-price]');
  const saleNode = qs('[data-sale-badge]');
  const addButton = qs('[data-add-to-cart]');
  const buyNowButton = qs('[name="checkout"]');
  const mobileAdd = qs('[data-mobile-add]');
  const addLabel = qs('[data-add-label]');
  const stockCopy = qs('[data-stock-copy]');
  const stockPulse = qs('.gta-stock-line__pulse');
  const mobileStock = qs('[data-mobile-stock]');

  const updateVariant = (variant) => {
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    priceNodes.forEach((node) => { node.textContent = formatMoney(variant.price); });
    if (addPrice) addPrice.textContent = formatMoney(variant.price);
    const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
    if (compareNode) {
      compareNode.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
      compareNode.classList.toggle('is-hidden', !hasCompare);
    }
    if (saleNode) {
      const saving = hasCompare ? Math.round((1 - variant.price / variant.compare_at_price) * 100) : 0;
      saleNode.textContent = `Save ${saving}%`;
      saleNode.classList.toggle('is-hidden', !hasCompare);
    }
    [addButton, buyNowButton, mobileAdd].forEach((button) => { if (button) button.disabled = !variant.available; });
    if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (mobileAdd) mobileAdd.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (stockCopy) stockCopy.textContent = variant.available ? 'In stock and ready for tracked dispatch' : 'Currently unavailable';
    if (mobileStock) mobileStock.textContent = variant.available ? 'In stock' : 'Sold out';
    stockPulse?.classList.toggle('is-out', !variant.available);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);
  };

  qsa('.gta-option-button').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.closest('[data-option-index]');
      qsa('.gta-option-button', group).forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const selectedLabel = qs('[data-selected-option]', group);
      if (selectedLabel) selectedLabel.textContent = button.dataset.optionValue || button.textContent.trim();
      updateVariant(getVariant());
    });
  });

  const quantity = qs('[data-quantity] input');
  const changeQuantity = (delta) => {
    if (!quantity) return;
    quantity.value = String(Math.max(1, Number.parseInt(quantity.value || '1', 10) + delta));
  };
  qs('[data-quantity-minus]')?.addEventListener('click', () => changeQuantity(-1));
  qs('[data-quantity-plus]')?.addEventListener('click', () => changeQuantity(1));
  quantity?.addEventListener('change', () => { quantity.value = String(Math.max(1, Number.parseInt(quantity.value || '1', 10))); });

  const form = qs('#gta-product-form');
  const toast = qs('[data-cart-toast]');
  const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const route = (path) => `${routesRoot}${String(path || '').replace(/^\//, '')}`;
  let toastTimer;
  let cartRequestBusy = false;

  const updateCartCount = (count) => {
    const itemCount = Math.max(0, Number(count || 0));
    qsa('[data-cart-count]').forEach((node) => { node.textContent = String(itemCount); });
    const cartLink = qs('.gta-cart-link');
    if (cartLink) cartLink.setAttribute('aria-label', `Open cart, ${itemCount} item${itemCount === 1 ? '' : 's'}`);
  };

  const refreshCartCount = async () => {
    try {
      const response = await fetch(route('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const cart = await response.json();
      updateCartCount(cart.item_count);
      return cart;
    } catch (_) {
      return null;
    }
  };

  const showToast = () => {
    if (!toast) return;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 4200);
  };

  const nativeFormFallback = (checkoutNow) => {
    if (!form) return;
    let checkoutInput = form.querySelector('input[data-gta-checkout-fallback]');
    if (checkoutNow) {
      if (!checkoutInput) {
        checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'checkout';
        checkoutInput.dataset.gtaCheckoutFallback = '';
        form.appendChild(checkoutInput);
      }
    } else if (checkoutInput) {
      checkoutInput.remove();
    }
    form.submit();
  };

  const addToCart = async (checkoutNow = false) => {
    if (!form || !variantIdInput || addButton?.disabled || cartRequestBusy) return;
    const original = addLabel?.textContent;
    const buyNowOriginal = buyNowButton?.textContent;
    cartRequestBusy = true;

    if (checkoutNow) {
      if (buyNowButton) buyNowButton.textContent = 'Preparing checkout…';
    } else if (addLabel) {
      addLabel.textContent = 'Adding…';
    }
    if (addButton) addButton.disabled = true;
    if (buyNowButton) buyNowButton.disabled = true;
    if (mobileAdd) mobileAdd.disabled = true;

    try {
      const response = await fetch(route('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(variantIdInput.value),
            quantity: Math.max(1, Number(quantity?.value || 1))
          }]
        })
      });
      if (!response.ok) {
        let message = 'Unable to add item';
        try {
          const payload = await response.json();
          message = payload.description || payload.message || message;
        } catch (_) {}
        throw new Error(message);
      }

      const cart = await refreshCartCount();
      if (cart) document.dispatchEvent(new CustomEvent('megetize:cart-updated', { detail: cart }));
      if (checkoutNow) window.location.assign(route('checkout'));
      else showToast();
    } catch (_) {
      nativeFormFallback(checkoutNow);
      return;
    } finally {
      cartRequestBusy = false;
      if (addLabel) addLabel.textContent = original || 'Add to cart';
      if (buyNowButton && buyNowOriginal) buyNowButton.textContent = buyNowOriginal;
      const selectedVariant = getVariant();
      const unavailable = selectedVariant ? !selectedVariant.available : false;
      if (addButton) addButton.disabled = unavailable;
      if (buyNowButton) buyNowButton.disabled = unavailable;
      if (mobileAdd) mobileAdd.disabled = unavailable;
    }
  };

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    addToCart(event.submitter?.name === 'checkout');
  });
  mobileAdd?.addEventListener('click', () => addToCart(false));
  window.addEventListener('pageshow', refreshCartCount);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshCartCount();
  });

  qsa('[data-mode]').forEach((button) => {
    button.addEventListener('click', () => {
      const lab = qs('[data-mode-visual]');
      const image = qs('[data-mode-image]');
      qsa('[data-mode]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      lab?.classList.add('is-changing');
      window.setTimeout(() => {
        if (image) {
          image.src = button.dataset.src || image.src;
          image.alt = `${button.dataset.title || 'Ambient'} light mode on the floating money lamp`;
        }
        const title = qs('[data-mode-title]');
        const temp = qs('[data-mode-temp]');
        if (title) title.textContent = button.dataset.title || '';
        if (temp) temp.textContent = button.dataset.temp || '';
        lab?.classList.remove('is-changing');
      }, 220);
    });
  });

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -50px' });
  qsa('.gta-reveal').forEach((section) => revealObserver.observe(section));

  const mobileBar = qs('[data-mobile-buy]');
  if (mobileBar && form) {
    const mobileObserver = new IntersectionObserver(([entry]) => {
      mobileBar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.1 });
    mobileObserver.observe(form);
  }
})();
